export const ACCESS_LEVEL_PERMISSION = {
  allCalendars: 'allCalendars',
  clientDetails: 'clientDetails',
  checkout: 'checkout',
}
